import React, { Component, ReactElement } from 'react'
import { LanguageContextProvider } from '../../React/Common/Contexts'
import { Route } from '../Annotation/Route'
import { RouteID } from '../Components/Molecules/Header/Types/Types'
import { RouteGuard } from '../Guards/RouteGuard'
import { ClientConfigurationList } from '../Components/Organisms/ClientConfiguration/List/ClientConfigurationList'

@Route(RouteID.CLIENT_CONFIGURATION)
export class ClientConfiguration extends Component {
    render(): ReactElement {
        return (
            <RouteGuard route={RouteID.CLIENT_CONFIGURATION}>
                <LanguageContextProvider>
                    <ClientConfigurationList />
                </LanguageContextProvider>
            </RouteGuard>
        )
    }
}
